import React from 'react';
import Image from 'next/image';
import Button from '@mui/material/Button';
import UniversalModal from '@/components/modal/UniversalModal';
import successIcon from '@/assets/job-title/success.png';

const SuccessModal = (props: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { open, setOpen } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <UniversalModal
      open={open}
      onClose={handleClose}
      title={<></>}
      headerHeight={76}
      headerBorder=""
      headerClass="font-semibold"
      width={418}
      maxWidth={false}
      footer={<></>}
      fullScreen={false}
    >
      <div className="p-10 pt-0 tablet:p-20 tablet:pt-3">
        <Image alt="" src={successIcon} width={64} height={77} />
        <p className="my-6 font-semibold text-xl">恭喜你，订阅成功！</p>
        <Button
          variant="contained"
          className="!w-full !h-12 !rounded-lg"
          onClick={handleClose}
        >
          返回
        </Button>
      </div>
    </UniversalModal>
  );
};

export default SuccessModal;
